import React from "react";
import { FilterableTableTransactions } from "../components/TableTransactions/FilterableTableTransactions";

export const RouteBookkeepingTransactions: React.FC = () => (
  <FilterableTableTransactions />
);
